import StepFooter, { StepFooterPropsI } from "./StepFooter";

export type { StepFooterPropsI };
export default StepFooter;
